import type { Format } from "@/shared/lib/types"
import { TaxonomyRail } from "./taxonomy-rail"

interface PostTypeCardsProps {
	postTypes: Format[]
	selectedTypeId?: string
}

export function PostTypeCards({ postTypes, selectedTypeId }: PostTypeCardsProps) {
	return (
		<TaxonomyRail
			items={postTypes}
			selectedId={selectedTypeId}
			getPath={(item) => `/f/${item.id}`}
		/>
	)
}
